var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticStyle: { padding: "0 10px 0 10px" } }, [
    _c(
      "div",
      { staticStyle: { "margin-top": "20px" } },
      [
        _c(
          "el-form",
          {
            attrs: {
              inline: false,
              size: "small",
              "label-width": "88",
              data: _vm.info,
            },
          },
          [
            _c(
              "el-row",
              { attrs: { gutter: 20 } },
              [
                _c(
                  "el-col",
                  { attrs: { span: 8 } },
                  [
                    _c("el-form-item", { attrs: { label: "订单状态：" } }, [
                      _vm._v(_vm._s(_vm.orderBaseInfo.orderState)),
                    ]),
                    _c(
                      "el-form-item",
                      { attrs: { label: "关联改签订单号：" } },
                      [
                        _vm._v(
                          _vm._s(_vm.orderBaseInfo.relationalChangedOrderNo)
                        ),
                      ]
                    ),
                    _c("el-form-item", { attrs: { label: "订单来源：" } }, [
                      _vm._v(_vm._s(_vm.orderBaseInfo.orderResource)),
                    ]),
                    _c("el-form-item", { attrs: { label: "乘客备注：" } }, [
                      _vm._v(_vm._s(_vm.orderBaseInfo.passengerRemark)),
                    ]),
                  ],
                  1
                ),
                _c(
                  "el-col",
                  { attrs: { span: 8 } },
                  [
                    _c("el-form-item", { attrs: { label: "联系电话：" } }, [
                      _c(
                        "div",
                        { staticStyle: { display: "flex" } },
                        [
                          _vm.userList.includes(
                            _vm.orderBaseInfo.contactPhoneNumber
                          )
                            ? _c("yd-link", {
                                attrs: {
                                  permi: "user_center_manage",
                                  value: _vm.orderBaseInfo.contactPhoneNumber,
                                  url: _vm.phoneUrl(
                                    _vm.info,
                                    _vm.orderBaseInfo.contactPhoneNumber
                                  ),
                                  need: true,
                                  type: "userInfo",
                                },
                              })
                            : _c("span", [
                                _vm._v(
                                  _vm._s(_vm.orderBaseInfo.contactPhoneNumber)
                                ),
                              ]),
                          _vm.isOpenSet
                            ? _c(
                                "span",
                                { staticStyle: { "padding-left": "10px" } },
                                [
                                  _c(
                                    "el-button",
                                    {
                                      directives: [
                                        {
                                          name: "has-permi",
                                          rawName: "v-has-permi",
                                          value: ["order_intercity_editPhone"],
                                          expression:
                                            "['order_intercity_editPhone']",
                                        },
                                      ],
                                      attrs: { type: "primary", size: "small" },
                                      on: { click: _vm.handleOpenSet },
                                    },
                                    [_vm._v("修改电话")]
                                  ),
                                ],
                                1
                              )
                            : _vm._e(),
                          _vm.isShowSet
                            ? _c(
                                "span",
                                { staticStyle: { "padding-left": "10px" } },
                                [
                                  _c("el-input", {
                                    staticStyle: {
                                      width: "9vw",
                                      padding: "0 3px",
                                    },
                                    attrs: {
                                      clearable: "",
                                      placeholder: "请输入电话号码",
                                      maxlength: "11",
                                      "show-word-limit": "",
                                    },
                                    model: {
                                      value: _vm.newMobile,
                                      callback: function ($$v) {
                                        _vm.newMobile = $$v
                                      },
                                      expression: "newMobile",
                                    },
                                  }),
                                  _c(
                                    "el-button",
                                    {
                                      attrs: { size: "mini" },
                                      on: { click: _vm.phoneCancel },
                                    },
                                    [_vm._v("取消")]
                                  ),
                                  _c(
                                    "el-button",
                                    {
                                      attrs: { type: "success", size: "mini" },
                                      on: { click: _vm.submit },
                                    },
                                    [_vm._v("确定")]
                                  ),
                                ],
                                1
                              )
                            : _vm._e(),
                        ],
                        1
                      ),
                    ]),
                    _c(
                      "el-form-item",
                      { attrs: { label: "优惠券/活动名称:" } },
                      [_vm._v(_vm._s(_vm.orderBaseInfo.couponOrActivityName))]
                    ),
                    _c("el-form-item", { attrs: { label: "后台备注：" } }, [
                      _c(
                        "div",
                        { staticStyle: { display: "flex" } },
                        [
                          _c("sapn", [
                            _vm._v(_vm._s(_vm.orderBaseInfo.backgroundRemark)),
                          ]),
                          _vm.isOpenRemark
                            ? _c(
                                "span",
                                { staticStyle: { "padding-left": "10px" } },
                                [
                                  _c(
                                    "el-button",
                                    {
                                      directives: [
                                        {
                                          name: "has-permi",
                                          rawName: "v-has-permi",
                                          value: ["order_intercity_setRemark"],
                                          expression:
                                            "['order_intercity_setRemark']",
                                        },
                                      ],
                                      attrs: { type: "primary", size: "mini" },
                                      on: { click: _vm.openBtn },
                                    },
                                    [_vm._v("设置备注\n                ")]
                                  ),
                                ],
                                1
                              )
                            : _vm._e(),
                          _vm.isShowRemark
                            ? _c(
                                "sapn",
                                { staticStyle: { "padding-left": "10px" } },
                                [
                                  _c("el-input", {
                                    staticStyle: { width: "20vw" },
                                    attrs: {
                                      type: "textarea",
                                      rows: 2,
                                      placeholder: "请输入备注",
                                    },
                                    model: {
                                      value: _vm.newRemark,
                                      callback: function ($$v) {
                                        _vm.newRemark = $$v
                                      },
                                      expression: "newRemark",
                                    },
                                  }),
                                  _c(
                                    "el-button",
                                    {
                                      attrs: { size: "mini" },
                                      on: { click: _vm.remarkCancel },
                                    },
                                    [_vm._v("取消")]
                                  ),
                                  _c(
                                    "el-button",
                                    {
                                      attrs: { type: "success", size: "mini" },
                                      on: { click: _vm.sumitRemark },
                                    },
                                    [_vm._v("确定")]
                                  ),
                                ],
                                1
                              )
                            : _vm._e(),
                        ],
                        1
                      ),
                    ]),
                  ],
                  1
                ),
                _c(
                  "el-col",
                  { attrs: { span: 8 } },
                  [
                    _c(
                      "el-form-item",
                      { attrs: { label: "下单人电话：" } },
                      [
                        _vm.userList.includes(
                          _vm.orderBaseInfo.orderPhoneNumber
                        )
                          ? _c("yd-link", {
                              attrs: {
                                permi: "user_center_manage",
                                value: _vm.orderBaseInfo.orderPhoneNumber,
                                url: _vm.phoneUrl(
                                  _vm.info,
                                  _vm.orderBaseInfo.orderPhoneNumber
                                ),
                                need: true,
                                type: "userInfo",
                              },
                            })
                          : _c("span", [
                              _vm._v(
                                _vm._s(_vm.orderBaseInfo.orderPhoneNumber)
                              ),
                            ]),
                      ],
                      1
                    ),
                    _c("el-form-item", { attrs: { label: "抵扣金额：" } }, [
                      _vm._v(_vm._s(_vm.orderBaseInfo.deductionAmount)),
                    ]),
                  ],
                  1
                ),
              ],
              1
            ),
          ],
          1
        ),
      ],
      1
    ),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }